/**
 *
 * Asynchronously loads the component for DraftFromTemplate
 *
 */

import { lazyLoad } from 'utils/loadable';

export const DraftFromTemplate = lazyLoad(
  () => import('./index'),
  module => module.DraftFromTemplate,
);
